import React, { useState, useEffect, useMemo,useRef } from "react";
import { FaSearch, FaCaretDown, FaRedoAlt } from "react-icons/fa";
import Sidebar from "../components/sidebar/Sidebar";
import apiService from "../utils/api";
import downloadIcon from '../assets/download.svg'; 
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import DeleteConfirmationModal from '../components/modals/DeleteConfirmationModal';
import "./FavouritePage.css";
import { TreeTable } from 'primereact/treetable';
import { Column } from 'primereact/column';
import { Info,Star } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { ProgressSpinner } from 'primereact/progressspinner';
import { Delete } from '@mui/icons-material';
import Breadcrumbs from "../components/Breadcrumbs";
import Loader from "./Loader";

const getUserId = () => {
  const storedUserId = sessionStorage.getItem('user_id');
  return storedUserId || ""; 
};

const getCleanContractId = (id) => {
  // Use a safe, bounded, and Unicode-aware regex
  const match = String(id).match(/\d{1,20}$/u); // Extracts up to 20 digits safely
  return match ? match[0] : id;
};

const getClientKey = (nodeKey) => {
  const parts = nodeKey.split("-");
  return parts[0] + "-" + parts[1]; // e.g., "CLIENT-3-TYPE" → adapts to client-type
};

const addLevels = (nodes, level = 0) => {
  if (!Array.isArray(nodes)) return [];
  return nodes.map((node, index) => {
    // Clone node to avoid mutating original
    const newNode = { ...node, level };
    // For files: Use contract_title as name, ensure file_url
    if (newNode.data?.type === "File") {
      newNode.data = {
        ...newNode.data,
        name: newNode.data.contract_title || newNode.data.name || "Unnamed Contract",
        file_url: newNode.data.url || `/files/${newNode.data.contract_id}`,
      };
    }
    // Recurse on children
    if (newNode.children && newNode.children.length > 0) {
      newNode.children = addLevels(newNode.children, level + 1);
    } else {
      newNode.children = []; // Ensure empty array for leaves
    }
    return newNode;
  });
};

const calculateModified = (modifiedAt) => {
  try {
    const now = new Date();
    const modifiedDate = new Date(modifiedAt.replace(/\//g, '-')); // Normalize date format
    if (isNaN(modifiedDate.getTime())) {
      return 'Unknown';
    }
    const diffMs = now - modifiedDate;
    const absDiffMs = Math.abs(diffMs);
    const diffHours = Math.floor(absDiffMs / (1000 * 60 * 60));
    const diffDays = Math.floor(absDiffMs / (1000 * 60 * 60 * 24));
    const diffMonths = Math.floor(absDiffMs / (1000 * 60 * 60 * 24 * 30));
    const suffix = diffMs >= 0 ? "ago" : "from now";

    if (absDiffMs < 1000 * 60) return "just now";
    if (diffHours < 24) return `${diffHours} hour${diffHours > 1 ? "s" : ""} ${suffix}`;
    if (diffDays < 30) return `${diffDays} day${diffDays > 1 ? "s" : ""} ${suffix}`;
    return `${diffMonths} month${diffMonths > 1 ? "s" : ""} ${suffix}`;
  } catch (error) {
    console.error("Error calculating modified time:", error);
    return 'Unknown';
  }
};

const statusColorMap = {
  'Pending Approval': '#F59E0B',
  'Approved': '#10B981',
  'Archived': '#6B7280',
  'Trashed': '#ff6b35',
  'Moved to Trash': '#ff6b35',
};


const FavouritesPage = () => {
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("");
  const [type, setType] = useState("");
  const [client, setClient] = useState("");
  const [days, setDays] = useState("");
  const [showColumnOptions, setShowColumnOptions] = useState(false);
  const [showDownloadMenu, setShowDownloadMenu] = useState(false);
  const [clientOptions, setClientOptions] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);
  const [typeOptions, setTypeOptions] = useState([]);
  const [contracts, setContracts] = useState([]);
  const [rawContracts, setRawContracts] = useState([]);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [contractToAction, setContractToAction] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);
  const [userName, setUserName] = useState('');
  const [isRestoring, setIsRestoring] = useState(false);
  const [expandedKeys, setExpandedKeys] = useState({});
  const navigate = useNavigate();
  const [nodes, setNodes] = useState([]);
  const [userEmail, setUserEmail] = useState('');
  const [isFavoriteLoading, setIsFavoriteLoading] = useState(false);
  const [favoriteNode, setFavoriteNode] = useState(null);
  const downloadRef = useRef(null);
  const [sortConfig, setSortConfig] = useState({ key: 'dateCreated', direction: 'desc' });
  const mandatoryColumns = ['name', 'status', 'dateCreated']; 
  const [visibleColumns, setVisibleColumns] = useState(() => {
    const savedColumns = localStorage.getItem('favouritesTableVisibleColumns');
    const initialColumns = {
      link: true,
      name: true, 
      clientName: true,
      dateCreated: true,
      status: true,
      modified: true,
      actions: true,
    };
   let cols = savedColumns ? JSON.parse(savedColumns) : initialColumns;
  mandatoryColumns.forEach(col => {
    if (cols.hasOwnProperty(col)) cols[col] = true;
  });

  return cols;
  });
  const [tempVisibleColumns, setTempVisibleColumns] = useState({ ...visibleColumns });
  const [loadingCount, setLoadingCount] = useState(0);

const userId = getUserId();
const startLoading = () => setLoadingCount((prev) => prev + 1);
  const stopLoading = () => setLoadingCount((prev) => Math.max(0, prev - 1));
  const isLoading = loadingCount > 0;
  const [snackbar, setSnackbar] = useState({ open: false, success: false, message: '' });
  const [originalHierarchy, setOriginalHierarchy] = useState([]);           // ← NEW
const [currentHierarchyMode, setCurrentHierarchyMode] = useState("default"); // ← NEW
const [switchingHierarchy, setSwitchingHierarchy] = useState(false);     // ← NEW


  useEffect(() => {
  if (showColumnOptions) {
    let temp = { ...visibleColumns };
    mandatoryColumns.forEach(col => {
      if (temp.hasOwnProperty(col)) temp[col] = true;
    });
    setTempVisibleColumns(temp);
  }
}, [showColumnOptions, visibleColumns]);

useEffect(() => {
  if (snackbar.open) {
    const timer = setTimeout(() => {
      setSnackbar((prev) => ({ ...prev, open: false }));
    }, 3000); 

    return () => clearTimeout(timer);
  }
}, [snackbar.open]);

  useEffect(() => {
    localStorage.setItem('favouritesTableVisibleColumns', JSON.stringify(visibleColumns));
  }, [visibleColumns]);

  useEffect(() => {
    const fetchDropdownData = async () => {
      startLoading();
      try {
        const statusData = await apiService.fetchData("metadata/contract-status");
        const contractTypeData = await apiService.fetchData("metadata/contract-type");
        setStatusOptions(statusData || []);
        setTypeOptions(contractTypeData || []);
      } catch (error) {
        console.error("Error fetching dropdown data:", error);
        setSnackbar({ open: true, success: false, message: `Failed to load dropdown data: ${error.message}` });
      } finally {
        stopLoading();
      }
    };
    fetchDropdownData();
  }, []);

  useEffect(() => {
    const storedName = sessionStorage.getItem('user_name') || 'Unknown User';
    const storedEmail = sessionStorage.getItem('user_emailId') || 'unknown@email.com';
    setUserName(storedName);
    setUserEmail(storedEmail);
  }, []);

  // Define fetchFavourites at the component level
const fetchFavourites = async () => {
  startLoading();
  try {
    if (!userId) {
      setSnackbar({ open: true, success: false, message: "User ID not found" });
      return;
    }
    const queryParams = `favourites-contracts?user_id=${userId}`;
    console.log('Fetching favourite contracts with URL:', queryParams);
    const response = await apiService.fetchData(queryParams);
    const hierarchy = response?.contract_hierarchy || [];
    setOriginalHierarchy(hierarchy);  
    const withLevels = addLevels(hierarchy);
    setNodes(withLevels);
    console.log("favourite contracts hierarchy with levels:", withLevels);

    if (withLevels.length === 0) {
      setSnackbar({ open: true, success: false, message: "No favourited contracts found" });
    }
  } catch (error) {
    console.error("Error fetching favourite contracts:", error);
    setSnackbar({ open: true, success: false, message: `Failed to load favourited documents: ${error.message}` });
    setNodes([]);
  } finally {
    stopLoading();
  }
};
// 🔹 Flatten hierarchical nodes for search and export
const flattenNodes = (nodeList) => {
  let flat = [];
  nodeList.forEach(node => {
    if (node.data?.type === 'File') flat.push(node.data);
    if (node.children?.length) flat = flat.concat(flattenNodes(node.children));
  });
  return flat;
};

// 🔹 Create a flat array of all files
const allFiles = flattenNodes(nodes);

// 🔹 Apply search
const filteredFiles = allFiles.filter(file =>
  (file.name || '').toLowerCase().includes(search.toLowerCase()) ||
  (file.clientName || '').toLowerCase().includes(search.toLowerCase()) ||
  (file.status || '').toLowerCase().includes(search.toLowerCase())
);

// 🔹 Build a filtered tree for TreeTable view
const filterTree = (nodeList) => {
  return nodeList
    .map(node => {
      if (node.data?.type === 'File') {
        const match =
          (node.data.name || '').toLowerCase().includes(search.toLowerCase()) ||
          (node.data.clientName || '').toLowerCase().includes(search.toLowerCase()) ||
          (node.data.status || '').toLowerCase().includes(search.toLowerCase());
        return match ? node : null;
      }
      const filteredChildren = filterTree(node.children || []);
      return filteredChildren.length > 0 ? { ...node, children: filteredChildren } : null;
    })
    .filter(Boolean);
};

const filteredNodes = search.trim() ? filterTree(nodes) : nodes;


useEffect(() => {
  fetchFavourites();
}, [userId]);

const toggleColumn = (key) => {
  if (mandatoryColumns.includes(key)) return; 
  setTempVisibleColumns((prev) => ({ ...prev, [key]: !prev[key] }));
};

const applyColumnChanges = () => {
  const newVisible = { ...tempVisibleColumns };
  mandatoryColumns.forEach(col => {
    if (newVisible.hasOwnProperty(col)) newVisible[col] = true;
  });
  setVisibleColumns(newVisible);
  localStorage.setItem('favouritesTableVisibleColumns', JSON.stringify(newVisible));
  setShowColumnOptions(false);
};

  const cancelColumnChanges = () => {
    setTempVisibleColumns(visibleColumns);
    setShowColumnOptions(false);
  };
 
const handleRemoveFromFavourites = async (node) => {
  const contractId = node.data.id;
  const userId = getUserId();

  let rawContractId = contractId;
  if (rawContractId && rawContractId.includes("CONTRACT-")) {
    rawContractId = rawContractId.replace("CONTRACT-", "");
  } else {
    setSnackbar({
      open: true,
      success: false,
      message: "Invalid contract ID format",
    });
    return;
  }

  const payload = {
    user_id: userId,
    contract_id: rawContractId,
  };

  setIsFavoriteLoading(true);
  setFavoriteNode(node);
  startLoading(); // Show loader
  try {
    const response = await apiService.postData(
      "favourites?is_favourite=false",
      payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (response?.status === "success" || response?.status === "Inactive Favourite") {
      await fetchFavourites(); // Refetch data for auto-refresh
      setSnackbar({
        open: true,
        success: true,
        message: "Contract removed from favourites",
      });
    } else {
      setSnackbar({
        open: true,
        success: false,
        message: response?.message || "Failed to remove from favourites",
      });
    }
  } catch (error) {
    console.error("Error removing favourite:", error);
    setSnackbar({
      open: true,
      success: false,
      message: "Error removing favourite",
    });
  } finally {
    setIsFavoriteLoading(false);
    setFavoriteNode(null);
    stopLoading(); // Hide loader
  }
};

const swapYearAndClient = (yearFirstNodes) => {
  const clientMap = new Map();

  yearFirstNodes.forEach((yearNode) => {
    const yearKey = yearNode.key;
    const yearName = yearNode.data.year || yearNode.data.name || "Unknown Year";

    (yearNode.children || []).forEach((clientNode) => {
      const clientName = clientNode.data.clientName || clientNode.data.name || "Unknown Client";
      const clientKey = clientNode.key.split("-")[0];

      if (!clientMap.has(clientKey)) {
        clientMap.set(clientKey, {
          key: clientKey,
          data: { type: "Folder", name: clientName, clientName },
          children: [],
        });
      }

      clientMap.get(clientKey).children.push({
        key: `${clientKey}-${yearKey}`,
        data: { type: "Folder", name: yearName },
        children: clientNode.children || [],
      });
    });
  });

  return Array.from(clientMap.values());
};

const handleSwitchHierarchy = () => {
  if (!originalHierarchy || originalHierarchy.length === 0) return;

  setSwitchingHierarchy(true);

  try {
    let processed;

    if (currentHierarchyMode === "default") {
      processed = swapYearAndClient(originalHierarchy);
      setCurrentHierarchyMode("client-first");
    } else {
      processed = originalHierarchy;
      setCurrentHierarchyMode("default");
    }

    const withLevels = addLevels(processed);
    setNodes(withLevels);
  } finally {
    setSwitchingHierarchy(false);
  }
};

  const removeNodeByKey = (nodes, keyToRemove) => {
    const keyParts = keyToRemove.split("-");
    if (keyParts.length === 1) {
      return nodes.filter((node) => node.key !== keyToRemove);
    }
    const newNodes = JSON.parse(JSON.stringify(nodes));
    let currentLevel = newNodes;
    for (let i = 0; i < keyParts.length - 1; i++) {
      const key = keyParts.slice(0, i + 1).join("-");
      const node = currentLevel.find((n) => n.key === key);
      if (!node || !node.children) return newNodes;
      currentLevel = node.children;
    }
    currentLevel.splice(
      currentLevel.findIndex((n) => n.key === keyToRemove),
      1
    );
    return newNodes;
  };



const getFlatFiles = () => flattenNodes(nodes).map(f => ({
  name: f.contract_title || f.name || "Unnamed Contract",
  clientName: f.clientName || "N/A",
  created: f.createdDate || f.created_at || "N/A",
  status: f.status || "Active",
  modified: f.modified || f.updated_at || f.createdDate || "N/A",
}));

// helper: builds rows from filtered files & visible columns
const buildExportRows = () => {
  const visibleKeys = Object.keys(visibleColumns).filter(k => visibleColumns[k] && k !== "actions" && k !== "link");
  const columnMap = {
    name: "Contract Name",
    clientName: "Client",
    dateCreated: "Created",
    status: "Status",
    modified: "Modified",
  };

  // ⚠️ use filteredFiles (search-aware), not flattenNodes(nodes)
  const files = filteredFiles.map(f => ({
    name: f.contract_title || f.name || "Unnamed Contract",
    clientName: f.clientName || "N/A",
    dateCreated: f.createdDate || f.created_at || "N/A",
    status: f.status || "Active",
    modified: f.modified || f.updated_at || f.createdDate || "N/A",
  }));

  const headers = visibleKeys.map(k => columnMap[k] || k);
  const rows = files.map(f => visibleKeys.map(k => f[k] || ""));
  return { headers, rows };
};

const exportToExcel = () => {
  const { headers, rows } = buildExportRows();
  if (rows.length === 0) {
    setSnackbar({ open: true, success: false, message: "No data available to export." });
    setShowDownloadMenu(false);
    return;
  }
  const csvRows = [
    headers.join(","),
    ...rows.map(r => r.map(v => `"${String(v).replace(/"/g, '""')}"`).join(",")),
  ];
  const csvString = csvRows.join("\n");
  const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = "favourites_export.csv";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  setShowDownloadMenu(false);
};

const exportToPDF = () => {
  const { headers, rows } = buildExportRows();
  if (rows.length === 0) {
    setSnackbar({ open: true, success: false, message: "No data available to export." });
    setShowDownloadMenu(false);
    return;
  }
  const doc = new jsPDF();
  autoTable(doc, { head: [headers], body: rows, theme: "grid", headStyles: { fillColor: "#ff6b35", textColor: "#ffffff" }, styles: { fontSize: 10, cellPadding: 3 } });
  doc.save("favourites_export.pdf");
  setShowDownloadMenu(false);
};








  return (
    <div className="favourites-page-container">
      <Sidebar />
      <div className="favourites-page-content">
       
        <Loader 
          isLoading={isLoading} 
          message="Fetching your top picks—almost there…" 
        />
        {!isLoading && (
          <>
            <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", marginBottom: "20px", gap: "10px" }}>
              <div className="favourites-table-header">
          <div className="header-section2">
            <Breadcrumbs />
            <br />
            <div style={{ 
      background: '#fff', 
      borderRadius: '8px', 
      padding: '24px 28px', 
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.06)', 
      borderLeft: '4px solid #ff6b35', 
      marginBottom: '24px' 
    }}>
      <h1 style={{ 
        fontSize: '24px', 
        fontWeight: 700, 
        color: '#212529', 
        margin: 0, 
        display: 'flex', 
        alignItems: 'center', 
        gap: '12px' 
      }}>
        <span style={{ 
          width: '28px', 
          height: '28px', 
          background: 'linear-gradient(135deg, #ff6b35 0%, #ff8c61 100%)', 
          borderRadius: '6px', 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center', 
          color: '#fff', 
          fontSize: '16px' 
        }}>
          📋
        </span>
        Your Favourite Contracts
      </h1>
    </div>
          </div>
        </div>
        {nodes && nodes.length > 0 &&  (
          <>
          <button
  onClick={handleSwitchHierarchy}
  disabled={switchingHierarchy}
  style={{
    background: switchingHierarchy ? "#ccc" : "#ff6b35",
    color: "white",
    padding: "8px 14px",
    borderRadius: "6px",
    fontWeight: "bold",
    marginLeft: "10px",
    cursor: switchingHierarchy ? "not-allowed" : "pointer",
    border:'none',
    width:'300px',
  }}
>
  {switchingHierarchy ? "Switching..." : "Switch → " + (currentHierarchyMode === "default" ? "Client First" : "Year First")}
</button>
              <input
                type="text"
                placeholder="Search..."
                value={search || ""}
                onChange={(e) => setSearch(e.target.value)}
                style={{
                  padding: "8px",
                  width: "170px",
                  border: "1px solid black",
                  borderRadius: "4px",
                }}
              />
              <button
                onClick={() => setShowColumnOptions(true)}
                style={{
                  cursor: "pointer",
                  padding: "4px 12px",
                  borderRadius: "6px",
                  background: "transparent",
                  color: "#4A4A4A",
                  border: "1px solid black",
                  fontSize: "16px",
                  fontWeight: 500,
                  width:'300px'
                }}
              >
                ⚙ Column options
              </button>


  <div style={{ position: "relative" }} ref={downloadRef}>
    <button
      onClick={() => setShowDownloadMenu(!showDownloadMenu)}
      style={{
        cursor: "pointer",
        padding: "4px 12px",
        borderRadius: "6px",
        background: "transparent",
        border: "1px solid #ff6b35",
        color: "#4A4A4A",
        fontSize: "16px",
        fontWeight: 500,
        display: "flex",
        alignItems: "center",
        gap: "8px",
      }}
    >
      <img src={downloadIcon} alt="Download" style={{ width: "16px", height: "20px" }} /> Download
    </button>
    {showDownloadMenu && (
      <div
        style={{
          position: "absolute",
          right: 0,
          marginTop: "6px",
          borderRadius: "6px",
          background: "white",
          border: "1px solid #e5e7eb",
          zIndex: 10,
        }}
      >
        <button
          onClick={exportToExcel}
          style={{
            cursor: "pointer",
            border: "none",
            display: "block",
            padding: "8px 12px",
            width: "120px",
            textAlign: "left",
            background: "none",
            color: "#4A4A4A",
          }}
        >
          Download CSV
        </button>
        <button
          onClick={exportToPDF}
          style={{
            cursor: "pointer",
            border: "none",
            display: "block",
            padding: "8px 12px",
            width: "120px",
            textAlign: "left",
            background: "none",
            color: "#4A4A4A",
          }}
        >
          Download PDF
        </button>
      </div>
    )}
  </div>
  </>
)}

            </div>
            <div style={{ overflow: "hidden" }}>
              <TreeTable
                value={filteredNodes}
                paginator
                rows={rowsPerPage || 10}
                rowsPerPageOptions={[10, 20, 50]}
                expandedKeys={expandedKeys}
                onToggle={(e) => setExpandedKeys(e.value)}
                showGridlines
                tableStyle={{ width: "100%", tableLayout: "fixed" }}
                rowClassName={(node) => {
                  if (node.data?.type === "Folder") return "folder-row";
                  return "";
                }}
                // onRowClick={(e) => {
                //   if (e.node.data?.type === "File" && e.node.data.file_url) {
                //     window.open(e.node.data.file_url, "_blank");
                //   }
                // }}
                emptyMessage={
    <div style={{
      textAlign: "center",
      padding: "40px 0",
      color: "#ff6b35",
      fontSize: "20px",
      fontWeight: 500,
      width: "100%"
    }}>
      Your favourites list is as empty as a coffee mug on Monday morning.
    </div>
  }
              >
                {visibleColumns.name && (
                  <Column
                    field="name"
                    header="Contract Name"
                    style={{ width: "25%", color: "black" }}
                    body={(node) => {
                      const isFolder = node.data?.type === "Folder";
                      const isExpanded = !!expandedKeys[node.key];
                      return (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "6px",
                            paddingLeft: `${node.level * 20}px`,
                            color: "black",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {node.children && node.children.length > 0 && (
                            <span
                              onClick={(e) => {
                                e.stopPropagation();
                                setExpandedKeys((prev) => {
                                  const newKeys = { ...prev };
                                  if (newKeys[node.key]) {
                                    delete newKeys[node.key];
                                  } else {
                                    newKeys[node.key] = true;
                                  }
                                  return newKeys;
                                });
                              }}
                              style={{
                                display: "inline-flex",
                                width: "18px",
                                height: "18px",
                                border: "1px solid black",
                                background: "white",
                                color: "#ff6b35",
                                justifyContent: "center",
                                alignItems: "center",
                                cursor: "pointer",
                                lineHeight: "18px",
                                verticalAlign: "middle",
                                fontSize: "18px",
                                marginLeft: "5px",
                              }}
                            >
                              {isExpanded ? "−" : "+"}
                            </span>
                          )}
                          {isFolder ? (
                            <span style={{ overflow: "hidden", textOverflow: "ellipsis" }}>
                              📂 {node.data.name}
                            </span>
                          ) : (
                            <span style={{ overflow: "hidden", textOverflow: "ellipsis" }}>
                              📄{" "}
                              <a
                                href={node.data.file_url}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ color: "#1976d2", textDecoration: "none" }}
                              >
                                {node.data.name}
                              </a>
                            </span>
                          )}
                        </div>
                      );
                    }}
                  />
                )}
                {visibleColumns.clientName && (
                  <Column
                    field="clientName"
                    header="Client"
                    style={{ width: "15%", textAlign: "center", color: "black" }}
                    body={(node) => {
                      if (node.level === 0) return null;
                      return (
                        <span style={{ display: "block", textAlign: "center", color: "black", overflow: "hidden", textOverflow: "ellipsis" }}>
                          {node.data.clientName}
                        </span>
                      );
                    }}
                  />
                )}
                {visibleColumns.dateCreated && (
                  <Column
                    field="createdDate"
                    header="Created"
                    style={{ width: "15%", textAlign: "center", color: "black" }}
                    sortable
                    body={(node) => {
                      if (node.data?.type === "Folder") return null;
                      return (
                        <span style={{ display: "block", textAlign: "center", color: "black", overflow: "hidden", textOverflow: "ellipsis" }}>
                          {node.data.createdDate}
                        </span>
                      );
                    }}
                  />
                )}
                {visibleColumns.status && (
                  <Column
                    field="status"
                    header="Status"
                    style={{ width: "15%", textAlign: "center", color: "black" }}
                    body={(node) => {
                      if (node.data?.type === "Folder") return null;
                      const status = node.data.status || "Active";
                      const backgroundStyle = {
                        background: statusColorMap[status] || "#ff6b35",
                        padding: "4px 8px",
                        borderRadius: "4px",
                        color: "#fff",
                        display: "inline-block",
                        textAlign: "center",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "normal", 
                        lineHeight: "1.2", 
                        maxHeight: "50px",
                      };
                      return <span style={backgroundStyle}>{status}</span>;
                    }}
                  />
                )}
                {visibleColumns.modified && (
                  <Column
                    field="modified"
                    header="Modified"
                    style={{ width: "15%", textAlign: "center", color: "black" }}
                    sortable
                    body={(node) => {
                      if (node.data?.type === "Folder") return null;
                      return (
                        <span style={{ display: "block", textAlign: "center", color: "black", overflow: "hidden", textOverflow: "ellipsis" }}>
                          {node.data.modified}
                        </span>
                      );
                    }}
                  />
                )}
                {visibleColumns.actions && (
  <Column
    header="Actions"
    style={{ width: "15%", textAlign: "center", color: "black" }}
    body={(node) => {
      if (node.data?.type !== "File") return null;
      return (
        <div style={{ display: "flex", gap: "12px", justifyContent: "center" }}>
          <Info
            style={{ cursor: "pointer", color: "#ff6b35", width: "16px", height: "16px" }}
            titleAccess="View Details"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              const cleanId = getCleanContractId(node.data.id);
              const clientKey = getClientKey(node.key);
              navigate("/categories", { state: { contractId: cleanId, clientKey } });
            }}
          />
     <Star
  style={{
    cursor: "pointer",
    color: "#ff6b35",
    width: "16px",
    height: "16px",
  }}
  titleAccess="Remove from favourites"
  onClick={(e) => {
    e.stopPropagation();  // prevent row click
    handleRemoveFromFavourites(node);
  }}
/>


          
          
        </div>
      );
    }}
  />
)}
              </TreeTable>
            </div>
          
          {showColumnOptions && (
            <div
              style={{
                position: "fixed",
                inset: 0,
                background: "rgba(0,0,0,0.4)",
                backdropFilter: "blur(6px)",
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "flex-end",
                zIndex: 1000,
              }}
            >
              <div
                style={{
                  width: "340px",
                  background: "#fff",
                  borderRadius: "8px",
                  overflow: "hidden",
                  marginTop: "100px",
                  marginRight: "20px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "10px 12px",
                    fontWeight: "700",
                    background: "#ff6b35",
                    color: "#fff",
                  }}
                >
                  <div>Column Options</div>
                  <button
                    onClick={cancelColumnChanges}
                    aria-label="Close"
                    style={{ background: "transparent", border: "none", fontSize: "25px", cursor: "pointer", color: "#fff" }}
                  >
                    ×
                  </button>
                </div>
                <div style={{ maxHeight: "50vh", overflowY: "auto", padding: "10px 12px" }}>
                  {['name', 'clientName', 'dateCreated', 'status', 'modified', 'actions'].map((key) => (
  <div
    key={key}
    style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '8px 0',
      borderBottom: '1px solid #f3f4f6',
    }}
  >
    <span style={{ fontSize: '14px', color: '#111827' }}>
      {key === 'name' ? 'Contract Name' : 
       key.charAt(0).toUpperCase() + key.slice(1).replace(/([A-Z])/g, ' $1')}
      {mandatoryColumns.includes(key) && <span style={{ color: '#ff6b35' }}> *</span>}
    </span>
    <button
      onClick={() => toggleColumn(key)}
      disabled={mandatoryColumns.includes(key)}
      aria-label={tempVisibleColumns[key] ? `Hide ${key}` : `Show ${key}`}
      style={{
        background: 'transparent',
        border: 'none',
        cursor: mandatoryColumns.includes(key) ? 'not-allowed' : 'pointer',
        opacity: mandatoryColumns.includes(key) ? 0.6 : 1,
      }}
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#000000"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
        <circle cx="12" cy="12" r="3" />
        {!tempVisibleColumns[key] && (
          <line x1="2" y1="2" x2="18" y2="18" stroke="#000000" strokeWidth="3" />
        )}
      </svg>
    </button>
  </div>
))}
                </div>
                <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px", padding: "10px 12px", borderTop: "1px solid #e5e7eb" }}>
                  <button
                    onClick={cancelColumnChanges}
                    style={{ background: "transparent", color: "#ff6b35", border: "1px solid #ff6b35", padding: "8px 14px", borderRadius: "6px" }}
                  >
                    Cancel
                  </button>
                  <button
                    onClick={applyColumnChanges}
                    style={{ background: "#ff6b35", color: "#fff", border: "1px solid #ff6b35", padding: "8px 14px", borderRadius: "6px" }}
                  >
                    OK
                  </button>
                </div>
              </div>
            </div>
          )}
         
          {snackbar.open && (
  <div
    style={{
      position: "fixed",
      bottom: "20px", // Changed from top to bottom
      left: "20px",   // Changed from right to left
      backgroundColor: snackbar.success ? "#4caf50" : "#ff6b35",
      color: "#fff",
      padding: "10px",
      borderRadius: "8px",
      zIndex: 1000,
      display: "flex",
      alignItems: "center",
      gap: "10px",
      fontSize: "20px", // Added to match 20px font size requirement
    }}
  >
    {snackbar.message}
    <button
      onClick={() => setSnackbar({ ...snackbar, open: false })}
      style={{ background: "transparent", border: "none", color: "#fff", cursor: "pointer", fontSize: '20px', marginTop: '5px' }}
    >
      ×
    </button>
  </div>
)}
{console.log("Rendering Snackbar with open:", snackbar.open)}
        </>
      )}
    </div>
  </div>
);
};

export default FavouritesPage;